import React, { useState, useEffect } from "react";
import "./NuComercial.css";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { setCommercialNum } from "../../Redux/actions/CommercialSlice";
import { NavbarJourney } from "../Navbar/NavbarJourney";
import { addVahanData } from "../../Redux/actions/NumBikeation";
import { Form, Input, Button, Row, Select, Col, Spin } from "antd/lib";
import car1 from "../../images/truck1.png";
import axios from "axios";

export default function PospNumcommercial() {
  const [formLayout] = useState("vertical");
  const [form] = Form.useForm();
  const { Option } = Select;
  const [open, setopen] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [BaseUrl, setBaseURL] = useState("");
  const iscommercialno = useSelector(
    (state) => state.vehicledetail.iscommercialno
  );

  const isuser = JSON.parse(localStorage.getItem("vibeUser"));
  useEffect(() => {
    const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
    setBaseURL(BASEURL);
  }, [BaseUrl]);
  const prefixSelector = (
    <Form.Item name="gender" noStyle>
      <Select
        style={{
          width: 70,
        }}
        defaultValue="+91"
      >
        <Option value="+91">+91</Option>
      </Select>
    </Form.Item>
  );
  const onFinish = (values) => {
    console.log(values);
    setLoading(true);
    setopen(true);
    if (isuser !== null) {
      var is_POSP = isuser.isPOSP === true ? 1 : 0;
      var posp_id = isuser.isPOSP === true ? isuser.pospid : "";
    } else {
      is_POSP = 0;
      posp_id = "";
    }
    const url = `${BaseUrl}v2/commercial_insurances/register`;
    axios
      .post(url, {
        commercial_vehicle_number: values.truckNumber,
        phonenumber: values.phonenumber,
      })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          let data = res?.data?.data;
          dispatch(setCommercialNum(data));
          const Url1 = `${BaseUrl}getVehicleDetails`;
          axios
            .post(Url1, {
              vehicleNumber: values.truckNumber,
            })
            .then((res) => {
              console.log(res);
              let truckResult = res?.data?.data;
              console.log(truckResult);
              dispatch(addVahanData(truckResult));
              history.push("/offCommercialMake");
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
            });
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setopen(false);
      });
  };
  const onFinishFailed = (values) => {
    console.log(values);
  };
  const handleInputChange = (e) => {
    e.target.value = e.target.value.toUpperCase();
    form.setFieldsValue({ truckNumber: e.target.value });
  };
  return (
    <>
      <Spin spinning={open}>
        <NavbarJourney />
        <div className="container w-100">
          <div className="row d-flex justify-content-center ">
            <div className="col-md-6 img-0 col-sm-0  p-2 ">
              <div className="m-4 ">
                <img className="img-fluid" src="./Images/posp-login.png"></img>
              </div>
            </div>
            <div className="col-md-6 col-sm-12 p-2 d-flex flex-column justify-content-center align-items-center p-4">
              <div
                className=" mt-4 text-blue"
                style={{ fontSize: "2rem", fontWeight: "400" }}
              >
                Save upto 85%* on Commercial Insurance
              </div>
              <div
                className=" mt-4"
                style={{ fontSize: "1rem", fontWeight: "400" }}
              >
                Stay home & renew in 2 minutes
              </div>
              <div className="d-flex align-items-center mt-4">
                <img
                  style={{ width: 20 }}
                  src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fflash.png?alt=media&token=c7213ae8-4a09-4a72-9800-e6eb5e59ff75"
                  alt=""
                />
                <small className="me-4 ms-2 text-success fw-bold">
                  Instant Policy
                </small>
                <img
                  style={{ width: 20 }}
                  src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fbank.png?alt=media&token=4cc16690-6e13-4219-a6ff-dd513fe04d1f"
                  alt=""
                />
                <small className="me-4 ms-2 text-warning fw-bold">
                  Best Prices
                </small>
                <img
                  style={{ width: 20 }}
                  src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fdocuments.png?alt=media&token=7923cd01-4150-4801-a4bf-8a42120125c9"
                  alt=""
                />
                <small className="me-4 ms-2 text-info fw-bold">
                  No Paperwork
                </small>
              </div>
              <Form
                layout={formLayout}
                form={form}
                style={{ width: "70%", paddingTop: "30px" }}
                requiredMark={false}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Form.Item
                  name="truckNumber"
                  rules={[
                    {
                      pattern: /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{3,4}$/i,
                      message: "Invalid Vehicle No",
                    },
                    { required: true, message: "Enter Vehicle No" },
                  ]}
                >
                  <Input
                    onChange={handleInputChange}
                    placeholder="Enter Truck Number (eg. DL1SAB1234)"
                  ></Input>
                </Form.Item>
                <Form.Item
                  name="phonenumber"
                  rules={[
                    {
                      pattern: /^([0|+[0-9]{1,5})?([6-9][0-9]{9})$/,
                      message: "Invalid Mobile No",
                    },
                    { required: true, message: "Enter Mobile No" },
                  ]}
                >
                  <Input
                    maxLength={10}
                    addonBefore={prefixSelector}
                    placeholder="Enter Mobile Number (eg. 9876543210)"
                  ></Input>
                </Form.Item>
                <Row gutter={24} className="justify-content-center">
                  <Col span={24}>
                    <Form.Item>
                      <Button
                        style={{ width: "100%", borderRadius: "7px" }}
                        loading={loading}
                        type="primary"
                        htmlType="submit"
                      >
                        View Price
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
              <div
                className=" mt-4 mb-5 h6 text-center"
                style={{ fontSize: "0.7rem" }}
              >
                <img
                  className="mx-1"
                  style={{ maxHeight: "0.8rem" }}
                  src={car1}
                  alt=""
                />{" "}
                <a href="#">Don't have a Truck number?</a>
                <a>| </a>
                <a href="#">Don't have a Truck number?</a>
              </div>
            </div>
          </div>
        </div>
      </Spin>
    </>
  );
}
